"use strict";

var _taggedTemplateLiteral = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  max-width: 960px;\n  padding: 0 1.0875rem 1.45rem;\n  padding-top: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.removeTextHover = exports.textHover = exports.textShadow = exports.textDecoration = exports.transform = exports.Container = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _styledSystem = require("styled-system"); // eslint-disable-next-line import/prefer-default-export


var Container = _styled.default.div(_templateObject());

exports.Container = Container;
var transform = (0, _styledSystem.style)({
  prop: 'transform',
  cssProperty: 'transform'
});
exports.transform = transform;
var textDecoration = (0, _styledSystem.style)({
  prop: 'textDecoration',
  cssProperty: 'textDecoration'
});
exports.textDecoration = textDecoration;
var textShadow = {
  textShadow: '0 0 3px #000000, 0 0 3px rgba(0, 0, 0, 0.6)'
};
exports.textShadow = textShadow;

var textHover = function textHover() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    accent: false,
    active: false,
    // is link active
    color: '#000',
    // font color
    hover: '#000',
    // font and underline color on hover and active state
    textDecoHover: 'none',
    // text decoration
    weight: 'normal',
    // font weight
    activeWeight: 'normal',
    // font weight when link is active
    width: '1px' // border bottom width

  };
  return {
    display: 'inline',
    color: options.active ? options.hover || options.color || 'inherit' : options.color || 'inherit',
    fontWeight: options.active ? options.activeWeight : options.weight || '1px',
    paddingBottom: '1px',
    borderBottom: "".concat(options.width || '1px', " solid transparent"),
    transition: 'border-bottom-color 0.2s ease-in-out, color 0.2s ease-in-out',
    borderBottomColor: options.active ? options.accent || options.hover || options.color || 'inherit' : 'transparent',
    'a:hover &, &:hover': {
      color: options.hover || options.color || 'inherit',
      borderBottomColor: options.accent || options.hover || options.color || 'inherit',
      textDecoration: options.textDecoHover
    }
  };
};

exports.textHover = textHover;

var removeTextHover = function removeTextHover() {
  var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'initial';
  return {
    color: color,
    paddingBottom: '0',
    borderBottom: "none",
    transition: 'none',
    borderBottomColor: 'transparent',
    'a:hover &, &:hover': {
      color: color,
      borderBottomColor: 'transparent'
    }
  };
};

exports.removeTextHover = removeTextHover;